<template>
  <MainHeader v-if="user && !bare" />
  <MainSidebar v-if="user && !bare" />
  <MobileNav v-if="user && user.role === 'admin' && !bare" />
  <ChatComponent v-if="user?.role === 'user' && name !== 'fella' && name !== 'proxywarehouse'" />
  <CustomAlert />
  <div class=" d-flex flex-column transition overflow-hidden bg-gray" :class="user && !bare ? 'main-content' : ' '" :style="{paddingTop: notificationMessage && user ? '140px' : ''}">
    <router-view />
    <!-- <MainFooter /> -->
  </div>
  
</template>

<script setup>
import { onMounted, onBeforeUnmount, watchEffect, ref, computed } from "vue";
import { useRoute } from "vue-router";
import stateStore from "./utils/store";
import { useHead } from '@vueuse/head';
import MainHeader from "./components/Layouts/MainHeader.vue";
import MainSidebar from "./components/Layouts/MainSidebar.vue";
import MobileNav from "./components/Layouts/MobileNav.vue";
// import MainFooter from "./components/Layouts/MainFooter.vue";
import CustomAlert from "./components/CustomAlert.vue";
import ChatComponent from "./components/Customer/ChatComponent.vue"
import { useAccountStore, useDarkModeStore } from "@/stores"
import { useChatStore } from "@/stores/chat.store";
import { storeToRefs } from "pinia"
const stateStoreInstance = stateStore;
const accountStore = useAccountStore()
const chatStore = useChatStore()   // unread live-chat count for the browser tab title
accountStore.getAccount();
accountStore.getMeta()
const { user, siteTitle, siteInfo, notificationMessage } = storeToRefs(accountStore)

const name = process.env.VUE_APP_VUE_NAME;
// full-screen pages (the phone chat app) leave out the dashboard menus
const route = useRoute();
const bare = computed(() => Boolean(route.meta && route.meta.bare));
// the chat app installs as its own app: its page points at its own manifest
watchEffect(() => {
  const link = document.querySelector('link[rel="manifest"]');
  if (link) link.setAttribute('href', location.hostname.startsWith('chat.') || route.path.startsWith('/admin/livechat') ? '/chat-manifest.json' : '/manifest.json');
});

const setFavicon = () => {
  const favicon = document.createElement('link');
  favicon.rel = 'icon';

  if (name === 'proproxy') {
    favicon.href = '/logo.png'; 
  } else if (name === 'global') {
    favicon.href = '/logo1.png'; 
  } else if (name === 'heros') {
    favicon.href = '/logo2.png'; 
  } else if (name === 'test') {
    favicon.href = '/logo3.png'; 
  } else if (name === 'fella') {
    favicon.href = '/logo4.jpg'; 
  } else if(name === 'katana') {
    favicon.href = '/logo7.png'
  } else if(name === 'psproxytech') {
    favicon.href = '/logo10.png'
  } else if(name === 'proxystyler') {
    favicon.href = '/logo11.png'
  } else {
    favicon.href = '/logo3.png'; 
  }

  document.head.appendChild(favicon);
};

// Set meta tags dynamically

watchEffect(() => {
  setFavicon();
  useHead({
    // unread live-chat messages show in the tab, e.g. "(3) AusProxies"
    title: (Number(chatStore.unreadCount) > 0 ? `(${Number(chatStore.unreadCount) > 99 ? '99+' : chatStore.unreadCount}) ` : '') + (siteTitle.value ? siteTitle.value : 'Proxy'),
    meta: [
      { name: 'description', content: siteInfo.value ? siteInfo.value : '' },
      { property: 'og:title', content: siteTitle.value ? siteTitle.value : 'Proxy'},
      { property: 'og:description', content: siteInfo.value ? siteInfo.value : ''},
    ],
  });

})

watchEffect(() => {
  document.body.classList.add("bg-body-secondary");
  useDarkModeStore().applyStoredTheme();   // dark unless this browser chose light
    if (stateStoreInstance.open) {
      document.body.classList.remove("sidebar-show");
      document.body.classList.add("sidebar-hide");
    } else {
      document.body.classList.remove("sidebar-hide");
      document.body.classList.add("sidebar-show");

    }
});
</script>